export enum ATSProviderEnum {
    ENAIRE = 'ENAIRE',
    INECO = 'INECO',
    SAERCO = 'SAERCO',
    FERRONATS = 'ferroNATS',
    UNKOWN = 'unkown'
}